import React from "react";
import { Tabs, Form, Row, Col, Button } from "antd";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AdnCard from "../common/adnCard/AdnCard";
import AdnTitle from "../common/adnPageTitle/AdnPageTitle";
import AdnInput from "../common/adnInput/AdnInput";
import AdnDatePicker from "../common/adnDatePicker/AdnDatePicker";
import AdnSatisfactionRate from "../common/adnSatisfactionLevel/AdnSatisfactionRate";
import AdnDropdown from "../common/adnDropdown/AdnDropdown";
import AdnFormOptions from "../common/adnFormOptions/AdnFormOptions";
import AdnTextArea from "../common/adnTextArea/AdnTextArea";
import QuizAnswerForm from "./QuizAnswerForm";
import {
  dateFormat,
  FollowUpEventStatus,
  EmployeeFollowUpEventQuizStatus,
} from "../common/GeneralConfigurations";
import { AppRoutes } from "../../AppRoutes";
import "./EmployeeFollowUpEventDetailListForm.css";
import AdnButton from "../common/adnButton/AdnButton";

const TabPane = Tabs.TabPane;

const EmployeeFollowUpEventDetailListForm = ({
  formEvent,
  initValues,
  handleFinish,
  handleCancel,
  users,
  loading,
  submitLoading,
  quizData,
  handleSaveQuiz,
  readonly,
  quizAnswersValues,
  handleAssignToSupervisor,
  isUserRH,
  setShowMessage,
  handleRedirect,
  status,
  employeeFollowUpEventId,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <AdnTitle title={t("employeeFollowUpEventDetailForm.title")} />
      <AdnCard loading={loading}>
        <Tabs defaultActiveKey="1" type="card" className="tab-title">
          <TabPane
            tab={t("employeeFollowUpEventDetailForm.tabs.details")}
            key="1"
          >
            <Form
              layout="vertical"
              style={{ marginTop: "1rem" }}
              name="basic"
              form={formEvent}
              initialValues={initValues}
              onFinish={handleFinish}
              autoComplete="off"
            >
              {initValues.status != FollowUpEventStatus.Canceled ? (
                <>
                  <Row gutter={16}>
                    <Col
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                      md={{ span: 24 }}
                      lg={{ span: 12 }}
                      xl={{ span: 12 }}
                      xxl={{ span: 12 }}
                    >
                      <AdnInput
                        name="employeeName"
                        label={t(
                          "employeeFollowUpEventDetailForm.labels.employee"
                        )}
                        placeholder={t(
                          "employeeFollowUpEventDetailForm.placeholders.employeeName"
                        )}
                        type="text"
                        readOnly={true}
                      />
                    </Col>
                    <Col
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                      md={{ span: 24 }}
                      lg={{ span: 12 }}
                      xl={{ span: 12 }}
                      xxl={{ span: 12 }}
                    >
                      <AdnInput
                        name="quizStatusDescription"
                        label={t(
                          "employeeFollowUpEventDetailForm.labels.quizStatus"
                        )}
                        placeholder={t(
                          "employeeFollowUpEventDetailForm.placeholders.quizStatus"
                        )}
                        type="text"
                        readOnly={true}
                      />
                    </Col>
                  </Row>

                  <Row gutter={16}>
                    <Col
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                      md={{ span: 24 }}
                      lg={{ span: 12 }}
                      xl={{ span: 12 }}
                      xxl={{ span: 12 }}
                    >
                      <AdnInput
                        name="eventType"
                        label={t("employeeFollowUpEventDetailForm.labels.type")}
                        placeholder={t(
                          "employeeFollowUpEventDetailForm.placeholders.eventType"
                        )}
                        type="text"
                        readOnly={true}
                      />
                    </Col>
                    <Col
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                      md={{ span: 24 }}
                      lg={{ span: 12 }}
                      xl={{ span: 12 }}
                      xxl={{ span: 12 }}
                    >
                      <AdnSatisfactionRate
                        disabled={!isUserRH}
                        companyLevel="companyLevel"
                        clientLevel="clientLevel"
                        projectLevel="projectLevel"
                        className="adnSatisfactionRate"
                      />
                    </Col>
                  </Row>

                  <Row gutter={16}>
                    <Col
                      xs={{ span: 24 }}
                      sm={{ span: 12 }}
                      md={{ span: 12 }}
                      lg={{ span: 6 }}
                      xl={{ span: 6 }}
                      xxl={{ span: 6 }}
                    >
                      <AdnDropdown
                        name="doneById"
                        label={t(
                          "employeeFollowUpEventDetailForm.labels.doneBy"
                        )}
                        placeholder={t(
                          "employeeFollowUpEventDetailForm.placeholders.doneByName"
                        )}
                        options={users}
                        disabled={initValues.date && !isUserRH}
                      />
                    </Col>
                    <Col
                      xs={{ span: 24 }}
                      sm={{ span: 12 }}
                      md={{ span: 12 }}
                      lg={{ span: 6 }}
                      xl={{ span: 6 }}
                      xxl={{ span: 6 }}
                    >
                      <AdnDatePicker
                        name="date"
                        label={t("employeeFollowUpEventDetailForm.labels.date")}
                        format={dateFormat}
                        disabled={!isUserRH && initValues.quizStatusId !== 0}
                      />
                    </Col>
                    <Col
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                      md={{ span: 24 }}
                      lg={{ span: 12 }}
                      xl={{ span: 12 }}
                      xxl={{ span: 12 }}
                    >
                      <AdnDropdown
                        name="status"
                        label={t(
                          "employeeFollowUpEventDetailForm.labels.eventStatus"
                        )}
                        placeholder={t(
                          "employeeFollowUpEventDetailForm.placeholders.eventStatus"
                        )}
                        options={status}
                      />
                    </Col>
                  </Row>

                  <Row gutter={16}>
                    <Col
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                      md={{ span: 24 }}
                      lg={{ span: 12 }}
                      xl={{ span: 12 }}
                      xxl={{ span: 12 }}
                    >
                      <AdnTextArea
                        name="feedBack"
                        label={t(
                          "employeeFollowUpEventDetailForm.labels.feedback"
                        )}
                        maxLength={2000}
                        rows={3}
                        showCount={true}
                      />
                    </Col>

                    <Col
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                      md={{ span: 24 }}
                      lg={{ span: 12 }}
                      xl={{ span: 12 }}
                      xxl={{ span: 12 }}
                    >
                      <AdnTextArea
                        name="note"
                        label={t("employeeFollowUpEventDetailForm.labels.note")}
                        maxLength={1000}
                        rows={3}
                        showCount={true}
                      />
                    </Col>
                  </Row>
                </>
              ) : (
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 24 }}
                  lg={{ span: 12 }}
                  xl={{ span: 12 }}
                  xxl={{ span: 12 }}
                >
                  <AdnTextArea
                    name="note"
                    label={t("employeeFollowUpEventDetailForm.labels.note")}
                    maxLength={500}
                    rows={3}
                    showCount={true}
                  />
                </Col>
              )}
              <br />
              <Row>
                <Col
                  xs={{ span: 12 }}
                  sm={{ span: 12 }}
                  md={{ span: 12 }}
                  lg={{ span: 12 }}
                  xl={{ span: 12 }}
                  xxl={{ span: 12 }}
                >
                  <Button
                    className="adn-outlined-button"
                    onClick={() => handleRedirect(initValues.eventType)}
                  >
                    {t(
                      "employeeFollowUpEventDetailForm.buttons.criticalSituation"
                    )}
                  </Button>
                </Col>
                <Col
                  xs={{ span: 12 }}
                  sm={{ span: 12 }}
                  md={{ span: 12 }}
                  lg={{ span: 12 }}
                  xl={{ span: 12 }}
                  xxl={{ span: 12 }}
                >
                  <AdnFormOptions
                    handleCancel={handleCancel}
                    loading={submitLoading}
                  />
                </Col>
              </Row>
            </Form>
          </TabPane>

          {initValues.quizStatusId !==
            EmployeeFollowUpEventQuizStatus.NoQuiz && (
            <TabPane
              tab={t("employeeFollowUpEventDetailForm.tabs.quiz")}
              key="2"
            >
              <QuizAnswerForm
                iAmSupervisor={true}
                readonly={readonly}
                eventTypeName={initValues.eventType}
                consultantName={initValues.employeeName}
                supervisorName={initValues.doneByName}
                quizStatusId={initValues.quizStatusId}
                quizStatusDescription={initValues.quizStatusDescription}
                submitLoading={submitLoading}
                handleCancel={handleCancel}
                handleSaveQuiz={handleSaveQuiz}
                quizData={quizData}
                quizAnswersValues={quizAnswersValues}
                handleAssignToSupervisor={handleAssignToSupervisor}
                isUserRH={isUserRH}
                setShowMessage={setShowMessage}
                storageKey={employeeFollowUpEventId ? `event_${employeeFollowUpEventId}` : null}
              />
            </TabPane>
          )}
        </Tabs>
      </AdnCard>
    </>
  );
};

export default EmployeeFollowUpEventDetailListForm;
